export const CagingEntryLoader = () => {
  return () => {
    return true;
  };
};
